module.exports = __webpack_public_path__ + "static/6305-woodrose-46-e80988e7f825e36d29104c78c89e10d0.jpg";